<template>
  <div class="container">
    <div class="row" v-if="user.user_type_id != 5">
      <div class="col-lg-4">
        <h2 class="h h--2 h--dark">Szkolenia online</h2>
        <p class="paragraph">
          Weź udział w szkoleniach online w dogodnym dla siebie terminie,
          wypełnij testy, sprawdź swoją wiedzę i przystąp do certyfikacji!
        </p>
        <p class="paragraph">
          <b>Masz więcej pytań? Skontaktuj się z Koordynatorem Geberit Pro.</b>
        </p>
      </div>
      <div class="col-lg-8">
        <div v-for="(webinars, category) in events.webinars">
          <div v-if="webinars.length > 0">
            <div class="webinar__row-category">{{ category }}</div>
            <div class="webinar__row">
              <div
                class="webinar__col"
                v-for="webinar in webinars"
                :key="webinar.id"
              >
                <a
                  :href="webinar.url"
                  target="_blank"
                  class="webinar__item-link"
                >
                  <div class="webinar__item">
                    <div class="webinar__item-desc">
                      <p>{{ webinar.short_description }}</p>
                      <p>
                        <b>{{ webinar.title }}</b>
                      </p>
                    </div>
                    <div class="webinar__item-desc">
                      <p
                        v-if="webinar.amISignedUp"
                        class="webinar__item-desc-registered"
                      >
                        <img
                          src="../../../assets/img/enlisted.png"
                          class="webinar__item-enlisted"
                        />
                        Zakończyłeś to szkolenie
                      </p>
                    </div>
                    <div class="webinar__item-link-arrow">
                      <p>Weź udział &raquo;</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <page-box-set-widget></page-box-set-widget>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";

export default {
  name: "OnlineTrainingComponent",
  data() {
    return {
      events: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  beforeRouteEnter(to, from, next) {
    Vue.axios({
      method: "get",
      url: "/webinars/index",
    })
      .then((datesResponse) => {
        next((vm) => {
          vm.events = datesResponse.data.data;
        });
      })
      .catch((error) => next(false));
  },
  mounted: function () {
    if (!this.user || this.user.id != 1) {
      this.$gtag.pageview({
        page_path: "/szkolenia-online",
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/app/home/calendar/OnlineTrainingComponent.vue